!function () {
  "use strict";
  var e, t = {
    9685: function (e, t, i) {
      var s = i(6072), n = i(4519);
      class r extends HTMLElement {
        constructor() {
          super(),
            this.parser = new DOMParser,
            this.resultsContainers = this.querySelectorAll(".predictive-search"),
            this.inputs = this.querySelectorAll(".search-input--desktop, .search-input--mobile");
          const e = sessionStorage.getItem("recentSearches");
          this.recentSearches = e ? JSON.parse(e) : [],
            this.openCloseEngine = this.closest("toggletip-engine"),
            this.toggletipEngines = document.querySelectorAll("toggletip-engine"),
            this.addGlobalListeners(),
            this.populateRecentSearches(this),
            this.addListeners()
        }
        clearRecentSearches() {
          this.recentSearches = [],
            sessionStorage.removeItem("recentSearches");
          const e = this.querySelector(".recent-searches");
          e && e.remove()
        }
        removeRecentSearch(e) {
          const t = "button" === e.target.type ? e.target : e.target.closest(".search-sidebar__remove"),
            i = t.dataset.search;
          if (!i) return;
          const s = this.recentSearches.indexOf(i);
          if (-1 !== s && (this.recentSearches.splice(s, 1), sessionStorage.setItem("recentSearches", JSON.stringify(this.recentSearches)), t.closest(".recent-searches__item").remove(), !this.recentSearches.length)) {
            const e = this.querySelector(".recent-searches");
            e && e.remove()
          }
        }
        handleRecentSearchClick(e) {
          this.inputs.forEach((t => {
            t.value = e.target.innerHTML,
              this.search({ target: t })
          }))
        }
        addRecentSearchesListeners() {
          this.querySelectorAll(".search-sidebar__button").forEach((e => {
            e.addEventListener("click", this.handleRecentSearchClick.bind(this))
          }));
          const e = this.querySelector(".search-sidebar__clear");
          e?.addEventListener("click", this.clearRecentSearches.bind(this));
          const t = this.querySelectorAll(".search-sidebar__remove");
          t?.forEach((e => {
            e.addEventListener("click", this.removeRecentSearch.bind(this))
          }))
        }
        removeRecentSearchesListeners() {
          this.querySelectorAll(".search-sidebar__button").forEach((e => {
            e.removeEventListener("click", this.handleRecentSearchClick.bind(this))
          }));
          const e = this.querySelector(".search-sidebar__clear");
          e?.removeEventListener("click", this.clearRecentSearches.bind(this));
          const t = this.querySelectorAll(".search-sidebar__remove");
          t?.forEach((e => {
            e.removeEventListener("click", this.removeRecentSearch.bind(this))
          }))
        }
        addListeners() {
          this.addRecentSearchesListeners()
        }
        close() {
          this.inputs.forEach((e => {
            e.blur()
          }));
          const e = this.querySelectorAll(".predictive-search");
          e && e.forEach((e => {
            e.classList.remove("open")
          }))
        }
        populateRecentSearches(e) {
          const t = e || document,
            i = t.querySelector("#search-sidebar"),
            s = t.querySelector(".recent-searches");
          if (s && s.remove(), !i) return;
          if (this.recentSearches.length) {
            const e = document.createElement("div");
            e.classList.add("search-sidebar__list", "recent-searches");
            const t = document.createElement("span");
            t.classList.add("search-sidebar__header", "text-md", "recent-searches__header"),
              t.innerText = `${searchStrings.recent_searches}`;
            const s = document.createElement("button");
            s.type = "button",
              s.classList.add("search-sidebar__clear", "button--xs-secondary"),
              s.innerText = `${searchStrings.clear_all}`,
              t.append(s),
              e.append(t);
            const n = document.createElement("ul");
            this.recentSearches.forEach((e => {
              const t = document.createElement("li");
              t.classList.add("search-sidebar__item", "recent-searches__item");
              const i = document.createElement("button");
              i.type = "button",
                i.innerHTML = e,
                i.classList.add("search-sidebar__button");
              const s = document.createElement("button");
              s.type = "button",
                s.classList.add("search-sidebar__remove"),
                s.innerHTML = "<span class='icon loaded' aria-hidden='true' focusable='false' role='presentation'>close</span>",
                s.dataset.search = e,
                t.appendChild(s),
                t.appendChild(i),
                n.appendChild(t)
            })),
              e.appendChild(n),
              i.prepend(e)
          }
        }
        globalSync(e) {
          document.querySelectorAll("predictive-search .search-input--desktop, predictive-search .search-input--mobile").forEach((t => {
            t.value = e
          }))
        }
        addGlobalListeners() {
          this.inputs.forEach((e => {
            e.addEventListener("input", (0, s.Ds)((e => {
              this.globalSync(e.target.value),
                this.search(e)
            }), 600))
          })),
            this.querySelectorAll(".predictive-search__close").forEach((e => {
              e.addEventListener("click", (() => {
                this.openCloseEngine.close()
              }))
            })),
            Array.from(this.querySelectorAll(".search-trigger")).forEach((e => {
              "input" === e.tagName.toLowerCase() && "search" === e.type && (
                e.addEventListener("focus", (e => {
                  this.isOpen || ((0, n.G)(), this.openCloseEngine.open(), setTimeout((() => {
                    const e = this.querySelector('.predictive-search__header input[type="search"]');
                    e && e.focus()
                  }), 50))
                })),
                e.addEventListener("click", (e => {
                  e.stopPropagation()
                }))
              )
            }))
        }
        setDefaultView() {
          if (this.defaultView) {
            const e = this.querySelector(".predictive-search__results-container");
            this.populateRecentSearches(this.defaultView),
              e.innerHTML = this.defaultView.innerHTML,
              this.addRecentSearchesListeners()
          }
        }
        /**
         * Check whether the current buyer locale supports Shopify's Predictive Search API.
         * Shopify exposes this via the `shopify-features` script tag in <head>.
         * Returns false for unsupported locales (e.g. Hebrew, Arabic, Chinese, Japanese),
         * in which case we fall back to the regular /search endpoint to avoid a 417
         * "Unsupported buyer locale" response.
         */
        supportsPredictiveApi() {
          try {
            const e = document.getElementById("shopify-features");
            if (!e) return false;
            return JSON.parse(e.innerHTML).predictiveSearch === true
          } catch (e) {
            return false
          }
        }
        async search(e) {
          const t = e.target.getAttribute("data-predictive-search"),
            i = this.querySelector('#predictive-search[data-predictive-search="' + t + '"]'),
            n = e.target.value,
            r = i.querySelector(".predictive-search__results-container"),
            o = document.querySelectorAll("predictive-search");
          if (!n) return void o.forEach((e => e.setDefaultView()));
          r.classList.add("loading");

          // Use /search/suggest when the buyer locale is supported by the Predictive Search API,
          // otherwise fall back to /search which works for all locales (including Hebrew).
          const endpoint = this.supportsPredictiveApi() ? "search/suggest" : "search";
          const extraParams = this.supportsPredictiveApi()
            ? "&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor"
            : "&type=product&options[prefix]=last&options[unavailable_products]=last";
          const a = window.Shopify.routes.root + `${endpoint}?q=${encodeURIComponent(n)}${extraParams}&section_id=predictive-search`;

          const { response: c, error: l } = await (0, s.wz)(a);
          if (l || !c.ok) return;
          const h = await c.text(),
            d = this.parser.parseFromString(h, "text/html").querySelector("#shopify-section-predictive-search"),
            p = [".search-sidebar", ".search-products"];
          o.forEach((e => {
            e.recentSearches.includes(n) || (
              e.recentSearches.length > 4 && e.recentSearches.pop(),
              e.recentSearches.unshift(n),
              sessionStorage.setItem("recentSearches", JSON.stringify(e.recentSearches)),
              e.setDefaultView()
            ),
              this.populateRecentSearches(d),
              p.forEach((t => {
                const i = d.querySelector(t);
                if (!i) return;
                const s = e.querySelector(".predictive-search__results-container").querySelector(t);
                s && (s.innerHTML = i.innerHTML)
              })),
              e.addRecentSearchesListeners()
          })),
            r.classList.remove("loading")
        }
        get isOpen() {
          return !!this.openCloseEngine.querySelector("[data-tooltip-trigger][open]")
        }
        open() {
          const e = this.querySelector("#predictive-search");
          e && (
            setTimeout((() => {
              const t = e.querySelector(".search-input--mobile"),
                i = window.matchMedia("(max-width: 1023px)").matches;
              t && i && t.focus()
            }), 100),
            this.defaultView || (this.defaultView = e.querySelector(".predictive-search__results-container").cloneNode(!0))
          )
        }
        disconnectedCallback() {
          this.isOpen && this.close()
        }
      }
      window.customElements.get("predictive-search") || window.customElements.define("predictive-search", r)
    },
    1434: function (e, t) {
      const i = "above-overlay", s = new Set;
      t.Z = class {
        isClosingTimer = null;
        attachedElements = new Set;
        constructor() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.querySelector("#main-content");
          this.container = e,
            this.overlay = document.createElement("div"),
            this.overlay.innerHTML = "&nbsp;",
            this.overlay.classList.add("overlay"),
            this.overlay.addEventListener("transitionend", (e => {
              "opacity" !== e.propertyName || this.isOpen || (
                this.attachedElements && this.attachedElements.size && this.attachedElements.forEach((e => {
                  this.detachElement(e)
                })),
                this.afterClosed && (this.afterClosed(), this.afterClosed = null),
                this.detachOverlay()
              ),
                "opacity" === e.propertyName && this.isOpen && this.afterOpened && (this.afterOpened(), this.afterOpened = null)
            })),
            s.add(this)
        }
        attachOverlay() { this.container.appendChild(this.overlay) }
        detachOverlay() { this.container.removeChild(this.overlay) }
        async open() {
          let { attachElements: e, afterOpened: t, beforeOpened: s } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          await this.attachOverlay(),
            this.isClosingTimer && (clearTimeout(this.isClosingTimer), this.isClosingTimer = null),
            s && s(),
            e && (
              e.forEach((e => { this.attachedElements.add(e) })),
              this.attachedElements.forEach((e => { e.classList.add(i) }))
            ),
            requestAnimationFrame((() => { this.overlay.classList.add("open") })),
            t && (this.afterOpened = t)
        }
        close() {
          let { delay: e, beforeClosed: t, afterClosed: i } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          t && t(),
            this.afterClosed = i;
          const s = () => {
            requestAnimationFrame((() => { this.overlay.classList.remove("open") }))
          };
          e ? this.isClosingTimer = setTimeout(s, e) : s()
        }
        detachElement(e) {
          this.attachedElements.has(e) && e.classList.contains(i) && (
            e.classList.remove(i),
            this.attachedElements.delete(e)
          )
        }
        get isOpen() { return this.overlay.classList.contains("open") }
        onClick() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => { };
          e && this.overlay.addEventListener("click", e)
        }
        removeOnClick() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => { };
          e && this.overlay.removeEventListener("click", e)
        }
        onHover() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => { };
          e && this.overlay.addEventListener("mouseover", (t => { this.isOpen && e(t) }))
        }
      }
    },
    4519: function (e, t, i) {
      i.d(t, { G: function () { return l } });
      var s = i(1434), n = i(6072), r = i(3397);
      const o = new s.Z;
      class a extends HTMLElement {
        constructor() {
          super(),
            this.headerEl = document.getElementById("nav-wrapper"),
            this.headerUXPosition = document.querySelector(".header").getAttribute("data-ux-position"),
            this.predictiveSearch = this.querySelector("predictive-search"),
            this.mobileView = this.dataset.mobileView ? this.dataset.mobileView : "floating",
            this.isWithinHeader = this.closest("#nav-wrapper"),
            this.overlayAttachingElements = this.isWithinHeader ? [this.headerEl] : [this.closest(".shopify-section"), this.headerEl],
            this.navigationItemTrigger = this.querySelector("[data-tooltip-trigger]"),
            this.navigationItemPopover = this.querySelector("[data-tooltip]"),
            this.arrowElement = this.querySelector("#arrow"),
            this.spacing = 16,
            this.isSearchTooltip = !!this.predictiveSearch,
            this.navigationItemPopover.addEventListener("click", (e => { e.stopPropagation() })),
            this.closeOnScroll = this.closeOnScroll.bind(this),
            this.addEventListener("click", (e => { e.stopPropagation() }));
          const e = this.closest(".shopify-section");
          e && e.addEventListener("click", (t => {
            t.target.closest("toggletip-engine") || c(e)
          })),
            this.handleResize = (0, n.Ds)((() => {
              this.isOpen && (
                window.matchMedia("(max-width: 1023px)").matches && "fullscreen" === this.mobileView
                  ? this.updateMobileFullscreen()
                  : this.update()
              )
            }), 100),
            this.container = this.closest(".shopify-section")?.querySelector(".section__wrapper")
        }
        update() {
          const e = this.navigationItemTrigger,
            t = this.navigationItemPopover,
            i = this.container?.getBoundingClientRect(),
            s = this.container?.classList.contains("container--full_bleed"),
            n = window.getComputedStyle(this.container),
            o = parseInt(n.paddingLeft),
            a = parseInt(n.paddingRight),
            c = [
              (0, r.cv)((() => window.matchMedia("(max-width: 1023px)").matches ? 16 : 8)),
              (0, r.RR)({
                boundary: "viewport",
                padding: {
                  left: s ? o : i?.left || 0,
                  right: s ? a : window.innerWidth - (i?.right || window.innerWidth)
                }
              }),
              (0, r.uY)({
                boundary: "viewport",
                padding: {
                  left: s ? o : i?.left || 0,
                  right: s ? a : window.innerWidth - (i?.right || window.innerWidth)
                },
                alignment: "start"
              }),
              (0, r.x7)({ element: this.arrowElement }),
              (0, r.dp)({
                apply(e) {
                  let { availableWidth: n, availableHeight: r } = e;
                  const c = s ? window.innerWidth - (o + a) : i?.width > 1600 ? 1600 : i?.width || Math.min(window.innerWidth, 1600);
                  Object.assign(t.style, {
                    maxWidth: `${c}px`,
                    maxHeight: t.classList.contains("tooltip--mobile") ? "" : "640px",
                    height: t.classList.contains("tooltip--mobile") ? `${r}px` : ""
                  })
                },
                padding: this.spacing,
                boundary: "viewport"
              })
            ];
          (0, r.oo)(e, t, { placement: "bottom-start", middleware: c, boundary: "viewport" }).then((e => {
            let { x: i, y: s, placement: n, middlewareData: r } = e, o = s;
            if (n.startsWith("top") && this.isSearchTooltip && (o = s - 60),
              Object.assign(t.style, { left: `${i}px`, top: `${o}px` }),
              !this.arrowElement) return;
            const { x: a, y: c } = r.arrow,
              l = { top: "bottom", right: "left", bottom: "top", left: "right" }[n.split("-")[0]];
            Object.assign(this.arrowElement.style, {
              left: null != a ? `${a}px` : "",
              top: null != c ? `${c}px` : "",
              right: "",
              bottom: "",
              [l]: `-${this.spacing}px`
            })
          }))
        }
        updateMobileFullscreen() {
          Object.assign(this.navigationItemPopover.style, {
            left: `${this.spacing}px`,
            top: `${this.spacing}px`,
            bottom: `${this.spacing}px`
          })
        }
        scrollIntoView(e) {
          if ("off" !== this.headerUXPosition) {
            const t = e.getBoundingClientRect();
            window.scrollTo(t.left, t.top + window.scrollY - this.headerEl.clientHeight)
          } else e.scrollIntoView()
        }
        open() {
          const e = window.matchMedia("(max-width: 1023px)").matches;
          this.isOpen || (
            e
              ? ("fullscreen" === this.mobileView
                ? (
                  "off" !== this.headerUXPosition && (
                    this.headerEl.style.marginTop = `-${this.headerEl.clientHeight}px`,
                    this.headerEl.props.lastScroll = window.scrollY,
                    this.headerEl.props.navMargin = this.headerEl.clientHeight
                  ),
                  this.navigationItemPopover.removeAttribute("style"),
                  this.updateMobileFullscreen(),
                  o.open({ attachElements: [this.closest(".shopify-section")] })
                )
                : (
                  this.navigationItemPopover.removeAttribute("style"),
                  this.update(),
                  o.open({ attachElements: [this.closest(".shopify-section"), this.headerEl] })
                ),
                (0, n.hO)(!0))
              : (
                this.navigationItemPopover.removeAttribute("style"),
                this.update(),
                o.open({ attachElements: this.overlayAttachingElements }),
                this.isWithinHeader || setTimeout((() => { this.scrollIntoView(this.navigationItemPopover) }), 100),
                document.addEventListener("scroll", this.closeOnScroll)
              ),
            this.navigationItemTrigger.setAttribute("open", "true"),
            o.onClick((e => { this.close() })),
            this.predictiveSearch && this.predictiveSearch.open(),
            (0, n.gp)(!0, this.close.bind(this)),
            window.addEventListener("resize", this.handleResize)
          )
        }
        close() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this.isOpen && (
            this.navigationItemTrigger.removeAttribute("open"),
            Object.assign(this.navigationItemPopover.style, {
              top: "-9999px",
              right: "-9999px",
              visibility: "hidden",
              opacity: "0",
              zIndex: "-1"
            }),
            e && this.overlayAttachingElements.forEach((e => { o.detachElement(e) })),
            o.close(),
            this.predictiveSearch && this.predictiveSearch.close(),
            (0, n.gp)(!1, this.close.bind(this)),
            window.matchMedia("(max-width: 1023px)").matches
              ? ((0, n.hO)(!1), this.headerEl.style.marginTop = "0px")
              : document.removeEventListener("scroll", this.closeOnScroll),
            window.removeEventListener("resize", this.handleResize)
          )
        }
        closeOnScroll() {
          !(0, n.v4)(this) && this.isOpen && this.close()
        }
        get isOpen() {
          return "true" === this.navigationItemTrigger.getAttribute("open") && o.isOpen
        }
        disconnectedCallback() {
          window.removeEventListener("resize", this.handleResize),
            this.isOpen && this.close(!0)
        }
      }
      window.customElements.get("toggletip-engine") || window.customElements.define("toggletip-engine", a);
      const c = e => {
        e.querySelectorAll("toggletip-engine").forEach((e => e.isOpen && e.close()))
      };
      const l = function () {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        const i = document.querySelectorAll("toggletip-engine");
        t
          ? i.forEach((i => i !== t && i.isOpen && i.close(e)))
          : i.forEach((t => t.isOpen && t.close(e)))
      }
    },
    6072: function (e, t, i) {
      i.d(t, { Ds: function () { return c }, gp: function () { return a }, hO: function () { return n }, v4: function () { return l }, wz: function () { return s } });
      const s = async function () {
        let e, t;
        try {
          e = await fetch(...arguments)
        } catch (e) {
          t = e
        }
        return { response: e, error: t }
      };
      const n = function () {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        const t = window.innerWidth - document.body.offsetWidth,
          i = document.getElementById("nav-wrapper");
        e
          ? (
            document.body.classList.add("no-scroll"),
            document.body.style.paddingRight = t + "px",
            i.style.paddingRight = t + "px"
          )
          : (
            document.body.classList.remove("no-scroll"),
            document.body.style.paddingRight = "0px",
            i.style.paddingRight = "0px"
          )
      };
      let r = () => { };
      const o = e => {
        "Escape" === e.key && (r(), window.removeEventListener("keydown", o))
      };
      const a = function () {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = arguments.length > 1 ? arguments[1] : void 0;
        t && (r = t),
          e && window.addEventListener("keydown", o),
          e || window.removeEventListener("keydown", o)
      };
      function c(e, t) {
        const i = this;
        let s;
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
          clearTimeout(s),
            s = setTimeout((function () { return e.apply(i, r) }), t)
        }
      }
      document.querySelectorAll(".local-scroll").forEach((e => {
        e.addEventListener("click", (e => {
          e.preventDefault(),
            e.stopPropagation();
          const t = e.target.getAttribute("href");
          !function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            const i = document.getElementById("nav-wrapper"),
              s = document.querySelector(".header").getAttribute("data-ux-position"),
              n = e.getBoundingClientRect().top;
            window.scrollTo({
              top: "off" !== s ? n + window.scrollY - t + parseFloat(i.style.marginTop) : n + window.scrollY - t,
              behavior: "smooth"
            })
          }(document.querySelector(t))
        }))
      }));
      const l = function (e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 120;
        const i = e.getBoundingClientRect(),
          s = document.documentElement;
        return i.top >= -t
          && i.left >= -t
          && i.bottom <= (window.innerHeight || s.clientHeight) + t
          && i.right <= (window.innerWidth || s.clientWidth) + t
      }
    }
  }, i = {};
  function s(e) {
    var n = i[e];
    if (void 0 !== n) return n.exports;
    var r = i[e] = { exports: {} };
    return t[e](r, r.exports, s), r.exports
  }
  s.m = t,
    e = [],
    s.O = function (t, i, n, r) {
      if (!i) {
        var o = 1 / 0;
        for (h = 0; h < e.length; h++) {
          i = e[h][0], n = e[h][1], r = e[h][2];
          for (var a = !0, c = 0; c < i.length; c++)
            (!1 & r || o >= r) && Object.keys(s.O).every((function (e) { return s.O[e](i[c]) }))
              ? i.splice(c--, 1)
              : (a = !1, r < o && (o = r));
          if (a) {
            e.splice(h--, 1);
            var l = n();
            void 0 !== l && (t = l)
          }
        }
        return t
      }
      r = r || 0;
      for (var h = e.length; h > 0 && e[h - 1][2] > r; h--) e[h] = e[h - 1];
      e[h] = [i, n, r]
    },
    s.d = function (e, t) {
      for (var i in t) s.o(t, i) && !s.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] })
    },
    s.o = function (e, t) { return Object.prototype.hasOwnProperty.call(e, t) },
    s.j = 8624,
    function () {
      var e = { 8624: 0, 8973: 0, 5534: 0, 3625: 0 };
      s.O.j = function (t) { return 0 === e[t] };
      var t = function (t, i) {
        var n, r, o = i[0], a = i[1], c = i[2], l = 0;
        if (o.some((function (t) { return 0 !== e[t] }))) {
          for (n in a) s.o(a, n) && (s.m[n] = a[n]);
          if (c) var h = c(s)
        }
        for (t && t(i); l < o.length; l++) r = o[l], s.o(e, r) && e[r] && e[r][0](), e[r] = 0;
        return s.O(h)
      },
        i = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
      i.forEach(t.bind(null, 0)),
        i.push = t.bind(null, i.push.bind(i))
    }();
  var n = s.O(void 0, [1216], (function () { return s(9685) }));
  n = s.O(n)
}();